import { render, staticRenderFns } from "./RejectedList.vue?vue&type=template&id=4b6b9c3d&"
import script from "./RejectedList.vue?vue&type=script&lang=js&"
export * from "./RejectedList.vue?vue&type=script&lang=js&"
import style0 from "./RejectedList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports